<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/membership')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="branch_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input name="name" v-validate="'required'" v-model="name" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Description</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input name="description" v-validate="'required'" v-model="description" type="text"></b-form-input>
                  <span class="error">{{ errors.first('description') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Membership Type</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select @change="changeMembershipType" class="w-100" v-model="membership_type_id">
                    <option value="null">Please select</option>
                    <option value="1">Monthly</option>
                    <option value="2">Yearly</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Membership Club Type</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select class="w-100" v-model="membership_club_type_id">
                    <option value="null">Please select</option>
                    <option value="1">All Club</option>
                    <option value="2">Single Club</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission" v-validate="'required'" v-model="comission" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 1</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission1" v-validate="'required'" v-model="comission1" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission1') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 2</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission2" v-validate="'required'" v-model="comission2" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission2') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 3</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission3" v-validate="'required'" v-model="comission3" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission3') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 4</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission4" v-validate="'required'" v-model="comission4" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission4') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 5</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission5" v-validate="'required'" v-model="comission5" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission5') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 6</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission6" v-validate="'required'" v-model="comission6" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission6') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 7</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission7" v-validate="'required'" v-model="comission7" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission7') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Comission 8</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="comission8" v-validate="'required'" v-model="comission8" v-bind="money"></money>
                  <span class="error">{{ errors.first('comission8') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Monthly Price</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="price" :value="yearlyPrice" v-validate="'required'" v-model="price" v-bind="money"></money>
                  <span class="error">{{ errors.first('price') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Processing Fee</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="processing_fee" v-validate="'required'" v-model="processing_fee" v-bind="money"></money>
                  <span class="error">{{ errors.first('processing_fee') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>First Month Rate</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" :disabled="membership_type_id == 2 ? true : false" name="first_month" v-model="first_month" v-bind="money"></money>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Last Month Rate</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" :disabled="membership_type_id == 2 ? true : false" name="last_month" v-model="last_month" v-bind="money"></money>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Period</label>
                </b-col>
                <b-col sm="10">
                  <!-- <b-form-select class="w-100" v-model="period_month">
                    <option value="null">Please select</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="6">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </b-form-select> -->
                  <b-form-input name="period_month" v-validate="'required'" v-model="period_month" type="number" min="0" max="100"></b-form-input>
                  <span class="error">{{ errors.first('period_month') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Start Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="configDate" v-model="start_date" name="start_date" class="w-100"></flat-pickr>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>End Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="configDate" v-model="end_date" name="end_date" class="w-100"></flat-pickr>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Keysoft Part ID</label>
                </b-col>
                <b-col sm="10">
                  <textarea name="keysoft_part_id" class="w-100" rows="3" v-model="keysoft_part_id"></textarea>
                  <span class="error">{{ errors.first('keysoft_part_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Is Advocacy</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_advocacy" name="is_advocacy"/>
                  <span class="error">{{ errors.first('is_advocacy') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Is Revenue</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_revenue" name="is_revenue"/>
                  <span class="error">{{ errors.first('is_revenue') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Comission</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_comission" name="is_comission"/>
                  <span class="error">{{ errors.first('is_comission') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">One Time Membership</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_one_time_membership" name="is_one_time_membership"/>
                  <span class="error">{{ errors.first('is_one_time_membership') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="is_bundling_session">Is Bundling Session</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_bundling_session" name="is_bundling_session"/>
                  <span class="error">{{ errors.first('is_bundling_session') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Show on Mobile</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_show_mobile" name="is_revenue" :sync="true"/>
                  <span class="error">{{ errors.first('is_show_mobile') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Show on Report</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_show_report" name="is_show_report" :sync="true"/>
                  <span class="error">{{ errors.first('is_show_report') }}</span>
                </b-col>
              </b-row>
              <b-row v-if="is_bundling_session" class="mb-20">
                <b-col sm="2">
                  <label>PT Session</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="bundling_pt_session_id" v-validate="'required'" v-model="bundling_pt_session_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in itemPTSession" :key="item.id" :value="item.id">{{item.name}} - Tier {{item.pt_tier}}</option>
                    </b-form-select>
                  </div>
                  <span class="error">{{ errors.first('bundling_pt_session_id') }}</span>
                </b-col>
              </b-row>
              <b-row v-if="is_bundling_session" class="mb-20">
                <b-col sm="2">
                  <label>Basic Membership Bundling Price</label>
                </b-col>
                <b-col sm="10">
                  <money class="form-control" name="basic_membership_bundling_price" v-validate="'required'" v-model="basic_membership_bundling_price" v-bind="money"></money>
                  <span class="error">{{ errors.first('basic_membership_bundling_price') }}</span>
                </b-col>
              </b-row>
              <b-row v-if="is_bundling_session" class="mb-20">
                <b-col sm="2">
                  <label>Total Count Base Membership as Comission</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input name="name" v-validate="'required'" v-model="total_count_base_membership_comission" type="text"></b-form-input>
                  <span class="error">{{ errors.first('total_count_base_membership_comission') }}</span>
                </b-col>
              </b-row>
              <b-row v-if="is_bundling_session" class="mb-20">
                <b-col sm="2">
                  <label>Total Count Base Membership Delay as Comission</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input name="name" v-validate="'required'" v-model="total_count_base_membership_delay_comission" type="text"></b-form-input>
                  <span class="error">{{ errors.first('total_count_base_membership_delay_comission') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_gallery">Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="selected" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Expired Days In Days</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input name="expired_advocacy_in_days" v-validate="'required'" v-model="expired_advocacy_in_days" type="text"></b-form-input>
                  <span class="error">{{ errors.first('expired_advocacy_in_days') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_gallery">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" @change="previewImage" accept="image/*" v-model="file" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('file') }}</span> -->
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import {Money} from 'v-money'

export default {
  name: 'addMembership',
  components: {Money},
  data: function () {
    return {
      dataBranch: [],
      branch_id: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR. ',
        suffix: '',
        precision: 0,
        masked: false
      },
      configDate: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      itemPTSession: [],
      imageData: '',
      name: '',
      file: null,
      keysoft_part_id: '',
      is_show_mobile: false,
      is_show_report: false,
      is_advocacy: false,
      is_revenue: false,
      is_comission: false,
      is_one_time_membership: false,
      is_bundling_session: false,
      bundling_pt_session_id: null,
      expired_advocacy_in_days: 0,
      membership_type_id: null,
      membership_club_type_id: null,
      description: '',
      comission: '',
      comission1: '',
      comission2: '',
      comission3: '',
      comission4: '',
      comission5: '',
      comission6: '',
      comission7: '',
      comission8: '',
      price: '',
      period_month: null,
      basic_membership_bundling_price: '',
      total_count_base_membership_comission: '',
      total_count_base_membership_delay_comission: '',
      membership_id: null,
      processing_fee: '',
      first_month: '',
      last_month: '',
      start_date: moment(new Date()).format('YYYY-MM-DD'),
      end_date: moment(new Date()).format('YYYY-MM-DD'),
      selected: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  computed: {
    yearlyPrice: function() {
      // disabled. request by adyt 23-10-2026
      /**
       * Original Code
       * if (this.membership_type_id == 2) {
          let calculatedTotal = this.price
          this.first_month = calculatedTotal * this.period_month
          return calculatedTotal
        }
       */
      if (this.membership_type_id == 4599122) {
        let calculatedTotal = this.price
        this.first_month = calculatedTotal * this.period_month
        return calculatedTotal
      }
    }
  },
  methods: {
    changeMembershipType (event) {
      this.price = 0
      this.first_month = 0
      this.last_month = 0
    },
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('branch_id', this.branch_id)
          data.append('name', this.name)
          data.append('photos', this.file)
          data.append('membership_type_id', this.membership_type_id)
          data.append('membership_club_type_id', this.membership_club_type_id)
          data.append('description', this.description)
          data.append('comission', this.comission)
          data.append('price', this.price)
          data.append('processing_fee', this.processing_fee)
          data.append('first_month', this.first_month)
          data.append('last_month', this.last_month)
          data.append('start_date', this.start_date)
          data.append('end_date', this.end_date)
          data.append('keysoft_part_id', this.keysoft_part_id)
          data.append('is_advocacy', this.is_advocacy ? 1 : 0)
          data.append('is_revenue', this.is_revenue ? 1 : 0)
          data.append('is_comission', this.is_comission ? 1 : 0)
          data.append('is_bundling_session', this.is_bundling_session ? 1 : 0)
          data.append('is_show_report', this.is_show_report ? 1 : 0)
          data.append('is_show_mobile', this.is_show_mobile ? 1 : 0)
          data.append('bundling_pt_session_id', this.bundling_pt_session_id)
          data.append('basic_membership_bundling_price', this.basic_membership_bundling_price)
          data.append('total_count_base_membership_comission', this.total_count_base_membership_comission)
          data.append('total_count_base_membership_delay_comission', this.total_count_base_membership_delay_comission)
          data.append('is_one_time_membership', this.is_one_time_membership ? 1 : 0)
          data.append('expired_advocacy_in_days', this.expired_advocacy_in_days)
          data.append('status', this.selected)
          data.append('period_month', this.period_month)
          axios.post('fitness/v1/membership/', data).then(response => {
            // console.log('test', response)
            this.$router.push('/membership')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('fitness/v1/pt_session?sorting=id&sorting_type=asc').then(response => {
        this.itemPTSession = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
